import { render, staticRenderFns } from "./bottomView.vue?vue&type=template&id=0c410c86&scoped=true"
import script from "./bottomView.vue?vue&type=script&lang=js"
export * from "./bottomView.vue?vue&type=script&lang=js"
import style0 from "./bottomView.vue?vue&type=style&index=0&id=0c410c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c410c86",
  null
  
)

export default component.exports